import { Box } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { Context } from "../LocalWrapper";

const CurrentDateTime = () => {
  const context = useContext(Context);

  const [currentDate, setCurrentDate] = useState("");
  const [currentTime, setCurrentTime] = useState("");

  const updateDateTime = () => {
    const now = new Date();
    // Format the date as 'dd-mm-yyyy'
    const formattedDate = `${String(now.getDate()).padStart(2, "0")}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${now.getFullYear()}`;

    // 12-hour format for time
    let hours = now.getHours();
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12; // Convert to 12-hour format
    hours = hours ? String(hours).padStart(2, "0") : "12"; // Handle 0 hours as 12

    const formattedTime = `${hours}:${minutes}:${seconds} ${ampm}`;

    setCurrentDate(formattedDate);
    setCurrentTime(formattedTime);
  };

  useEffect(() => {
    // Update the date and time every second
    const timer = setInterval(updateDateTime, 1000);

    // Cleanup the timer when the component is unmounted
    return () => clearInterval(timer);
  }, []);

  return (
    <Box
      sx={{
        display: { xs: "none", sm: "none", md: "flex", lg: "flex" },
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        color: "var(--paragraph)",
        // backgroundColor: "var(--primary)",
        fontSize: "12px",
        fontWeight: "900",
        width: "82px",
        height: "100%",
        // padding: "0px 5px",
        lineHeight: "15px",
        borderInlineStart: "1px solid #dee2e6 ",
      }}
      //   className="ps-2  py-2"
      dir={context.dir}
    >
      <Box sx={{ padding: "0px", margin: "0px", fontWeight: "600" }}>
        {currentTime}
      </Box>
      <Box sx={{ padding: "0px", margin: "0px", fontWeight: "600" }}>
        {currentDate}
      </Box>
    </Box>
  );
};

export default CurrentDateTime;
